var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 3.86667C11.8778 3.86667 13.1444 4.67778 13.8667 5.35556L16.6889 2.6C14.9555 0.988889 12.7 0 9.99998 0C6.08887 0 2.71109 2.24444 1.06665 5.51111L4.29998 8.02222C5.11109 5.61111 7.35554 3.86667 9.99998 3.86667Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 10.2222C19.6 9.39996 19.5333 8.79996 19.3889 8.17773H10V11.8888H15.5111C15.4 12.8111 14.8 14.2 13.4667 15.1333L16.6222 17.5777C18.5111 15.8333 19.6 13.2666 19.6 10.2222Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31111 11.9778C4.1 11.3556 3.97778 10.6889 3.97778 10C3.97778 9.31111 4.1 8.64444 4.3 8.02222L1.06667 5.51111C0.388889 6.86666 0 8.38889 0 10C0 11.6111 0.388889 13.1333 1.06667 14.4889L4.31111 11.9778Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99986 20C12.6999 20 14.9665 19.1111 16.6221 17.5778L13.4665 15.1333C12.6221 15.7222 11.4887 16.1333 9.99986 16.1333C7.35541 16.1333 5.11097 14.3889 4.31097 11.9778L1.07764 14.4889C2.72208 17.7556 6.08875 20 9.99986 20Z",
    fill: "#34A853"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.24fca9aa290c1adbd6f24825feb41a10.svg";
export { ForwardRef as ReactComponent };